var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "success icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.7244 10.0857V11.0057C19.7232 13.1621 19.0727 15.2604 17.8699 16.9875C16.6671 18.7147 14.9764 19.9782 13.0499 20.5896C11.1235 21.201 9.06454 21.1276 7.18015 20.3803C5.29576 19.633 3.6869 18.2518 2.59351 16.4428C1.50012 14.6338 0.980789 12.4938 1.11297 10.342C1.24514 8.19029 2.02175 6.14205 3.32696 4.5028C4.63217 2.86354 6.39606 1.72111 8.35555 1.24587C10.315 0.770634 12.3651 0.988061 14.2001 1.86572",
    stroke: "#48B16E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M19.7248 3.00574L10.409 13.0157L7.61426 10.0157",
    stroke: "#48B16E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.6acd476cd72104136c6ea45a7613c517.svg";
export { ForwardRef as ReactComponent };